<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Parcelas em aberto' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <ion-card class="card-down" *ngFor="let boleto of boletoAbertos">
    <ion-grid>
      <ion-row>
        <ion-col>
          <h2 class="titulo two-lines">{{boleto.plano}}</h2>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <h2 class="bold-2">{{boleto.planoTipo}}</h2>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <p style="font-weight: 600">
            {{'Vencimento:' | translate}}
            <span style="font-weight: 400"
              >{{boleto.dataVencimento | dateFormat:'ddmmyyyy'}}</span
            >
          </p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <h2 *ngIf="isAtrasado(boleto.dataVencimento)" class="bold-2 red">
            {{'VENCIDO' | translate}}
          </h2>

          <h2 *ngIf="!isAtrasado(boleto.dataVencimento)" class="bold-2 orange">
            {{'EM ABERTO' | translate}}
          </h2>
        </ion-col>

        <ion-col>
          <p>{{boleto.valorAtual | money | async}}</p>
        </ion-col>
      </ion-row>

      <div class="down">
        <ion-button
          class="btn-default"
          (click)="abrirBoleto(boleto.id)"
          type="button"
        >
          {{'Visualizar Fatura' | translate}}
        </ion-button>
      </div>
    </ion-grid>
  </ion-card>

  <sem-registro *ngIf="boletoAbertos.length == 0"></sem-registro>
</ion-content>
